import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

function PurchaseConfirm({match, history}) {
    const {t} = useTranslation();
    // {t('')}

    return (
        <div className="hero bg-base-200 min-h-screen">
            <div className="hero-content text-center">
                <div className="">
                    <img
                        className={'w-2/4 m-auto mb-5'}
                        alt={'logo firmame'}
                        src={'https://firmame.io/files/LOGO_MAIN'}/>
                    <p className="text-xl py-6">
                        {t('PURCHASE COMPLETE')}<br/><br/>
                        {t('PURCHASE COMPLETE CHECK EMAIL')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default PurchaseConfirm;
